export const ap = {
  apiName: '项目来源',
  bidderCompanyName: '企业名称',
  bidderLinkName: '联系人',
  bidderMobilePhone: '联系方式',
  businessLicense: '营业执照',
  projectName: '标段名称',
  validityPeriod: '投标有效期(天)',
  projectCode: '项目编号',
  tenderCompanyName: '招标人名称',
  openingDate: '开标时间',
  rojectArea: '项目地区',
  bankName: '保函出具银行',
  tenderFileId: '招标文件',
  issuingBank: '保函出具银行',
  bidderLinkAdress: '企业办公地址',
  guaranteeAmount: '投标保证金金额(万元)',
  productAmount: '保函费用',
  urgent: '是否加急',
  remarks: '备注',
}

export const ahGzDzBank = {
  bidderCompanyName: '投标人企业名称',
  bidderLinkName: '联系人',
  bidderMobilePhone: '联系方式',
  businessLicense: '营业执照',
  openingPermit: '开户许可证扫描件',
  attr1: '年度出具分离式投标保函承诺函',
  attr2: '批量分离式保函委托协议盖章扫描件',
  attr3: '法定代表人证明书及授权委托证明扫描件',
  expressNumber: '快递单号',
  projectName: '标段名称',
  tenderCompanyName: '招标人名称',
  openingDate: '开标时间',
  bankName: '保函出具银行',
  tenderFileId: '招标文件',
  guaranteeAmount: '投标保证金金额(万元)',
  productAmount: '保函费用',
}

export const letter = {
  projectSourceName: '项目来源',
  bidderCompanyName: '企业名称',
  bidderLinkName: '联系人',
  bidderMobilePhone: '联系方式',
  businessLicense: '营业执照',
  projectName: '标段名称',
  validityPeriod: '投标有效期(天)',
  projectCode: '项目编号',
  tenderCompanyName: '招标人名称',
  openingDate: '开标时间',
  rojectArea: '项目地区',
  bankName: '保函出具银行',
  tenderFileId: '招标文件',
  partnerName: '担保机构',
  guaranteeAmount: '投标保证金金额(万元)',
  productAmount: '保函费用',
  basicPay: '支付方式选择',
  bankCardNo: '银行账户号码',
  bankCardName: '银行账户户名',
  remarks: '备注',
}


// 基础银行保函配置
const baseAg = {
  apiName: '项目来源',
  bidderCompanyName: '投标人名称',
  bidderLinkName: '联系人',
  bidderSocialCreditCode: '社会统一信用代码',
  bidderMobilePhone: '联系方式',
  projectName: '标段名称',
  projectCode: '标段编号',
  bidderLinkMail: '联系邮箱',
  guaranteeStartDate: '开标日期',
  validityPeriod: '投标有效期(天)',
  tenderCompanyName: '招标人名称',
  // openingDate: '开标时间',
  tenderLinkMail: '项目联系人邮箱',
  tenderMobilePhone: '项目联系人电话',
  tenderLinkAddress: '项目联系人地址',
  tenderFileId: '招标文件',
  issuingBank: '保函出具银行',
  guaranteeAmount: '投标保证金金额(万元)',
  productAmount: '保函费用',
  urgent: '是否加急',
  remarks: '备注',
  rojectAreaName: '项目地区',
  partnerName: '担保保险机构',
  exectronicView: '保函形式',
};
export const ag = {
  ...baseAg,
  bidderLinkAdress: '企业办公地址（同保函邮寄地址）',
  mailPaperGuaranteeView: '是否需邮寄纸质保函',
}
export const agDz = {
  ...baseAg,
  bidderLinkAdress: '企业办公地址',
}
export const performance = {
  bidderCompanyName: '企业名称',
  orgLegalPerson: '企业法人',
  bidderSocialCreditCode: '社会统一信用代码',
  bidderLinkName: '联系人',
  bidderMobilePhone: '联系方式',
  projectName: '标段名称',
  projectCode: '标段编号',
  tenderCompanyName: '招标人名称',
  performanceGuaranteePeriod: '担保期限',
  guaranteeAmount: '担保金额(万元)',
  writingParty: '出函方',
  bidderQualification: '是否具有企业资质',
  dutyPaidProof: '企业资质',
  tenderFileId: '招标文件',
  tenderMateriaFileId: '中标通知书',
  performGuaranteeType: '履约保函类型',
}
